var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 7.2a.6.6 0 01.596.53L12 7.8v2.4a1.8 1.8 0 01-1.694 1.797L10.2 12H1.8a1.804 1.804 0 01-1.797-1.694L0 10.2V7.8a.6.6 0 011.196-.07l.004.07v2.4c0 .305.234.56.53.596l.07.004h8.4a.6.6 0 00.596-.53l.004-.07V7.8a.6.6 0 01.6-.6zM6.368.126l.056.05 3 3a.6.6 0 01-.792.898l-.056-.05L6.6 2.05V7.5a.6.6 0 01-1.196.07L5.4 7.5V2.049L3.424 4.024a.6.6 0 01-.792.05l-.056-.05a.6.6 0 01-.05-.792l.05-.056 3-3a.6.6 0 01.73-.092l.062.042z",
    fill: "currentColor"
  })));
}

export default SvgUpload;